import { NodeModel } from '@minoru/react-dnd-treeview';
import { Modal } from '../BaseModal';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../context';

interface FilterInconsistenciesProps {
    setModalOpen: (state: boolean) => void;
    isOpen: boolean;
    startDate: string;
    endDate: string;
    employee: NodeModel[];
}

export const FilterInconsistencies = ({
    setModalOpen,
    isOpen,
    employee,
    startDate,
    endDate,
}: FilterInconsistenciesProps) => {
    const {
        handlerValidateNovelties,
        langResources,
        inconsistenciesTypesToFilter,
        setInconsistenciesTypesToFilter,
    } = useContext(AppContext);

    const [inconsistenciesTypes, setInconsistenciesTypes] = useState<number[]>([]);
    const [isAll, setIsAll] = useState(false);

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handlerSubmit = () => {
        setModalOpen(false);
        setInconsistenciesTypesToFilter(inconsistenciesTypes);
        handlerValidateNovelties(employee, startDate, endDate, inconsistenciesTypes);
    };

    const handleInputChange = (type: number) => {
        if (inconsistenciesTypes.includes(type)) {
            setInconsistenciesTypes(inconsistenciesTypes.filter((i) => i !== type));
        } else {
            setInconsistenciesTypes([...inconsistenciesTypes, type]);
        }
    };

    useEffect(() => {
        if (isAll) {
            setInconsistenciesTypes([1, 2, 3, 4, 5, 6, 7]);
        } else {
            setInconsistenciesTypes([]);
        }
    }, [isAll]);

    return (
        <Modal
            isOpen={isOpen}
            modalTitle={
                langResources['inconsistencies.modal'][
                'filter.inconsistencies.title'
                ]
            }
            onClose={handleCloseModal}
            onSubmit={handlerSubmit}
            disableSubmit={inconsistenciesTypes.length === 0}
            widthCustom='820px'
        >
            <div className='modal-body text-black border justify-content-center rounded mb-2 row m-2'>
                <div>
                    <div className='row  '>
                        <div className='col-4 checked-custom  mt-2'>
                            <input
                                className='form-check-input me-1'
                                type='checkbox'
                                name='withoutWorkshift'
                                id='withoutWorkshift'
                                checked={inconsistenciesTypes.includes(1)}
                                onChange={(e) => handleInputChange(1)}
                            />

                            <label htmlFor='withoutWorkshift'>
                                {
                                    langResources['inconsistencies.modal'][
                                    'withoutWorkshift.label'
                                    ]
                                }
                            </label>
                        </div>

                        <div className='col-4 checked-custom  mt-2'>
                            <input
                                className='form-check-input me-1'
                                type='checkbox'
                                name='withoutTimeAttendance'
                                id='withoutTimeAttendance'
                                checked={inconsistenciesTypes.includes(2)}
                                onChange={(e) => handleInputChange(2)}
                            />

                            <label htmlFor='withoutTimeAttendance'>
                                {
                                    langResources['inconsistencies.modal'][
                                    'withoutTimeAttendance.label'
                                    ]
                                }
                            </label>
                        </div>

                        <div className='col-4 checked-custom  mt-2'>
                            <input
                                className='form-check-input me-1'
                                type='checkbox'
                                name='lateArrival'
                                id='lateArrival'
                                checked={inconsistenciesTypes.includes(3)}
                                onChange={(e) => handleInputChange(3)}
                            />

                            <label htmlFor='lateArrival'>
                                {
                                    langResources['inconsistencies.modal'][
                                    'lateArrival.label'
                                    ]
                                }
                            </label>
                        </div>

                        <div className='col-4 checked-custom  mt-2'>
                            <input
                                className='form-check-input me-1'
                                type='checkbox'
                                name='earlyArrival'
                                id='earlyArrival'
                                checked={inconsistenciesTypes.includes(4)}
                                onChange={(e) => handleInputChange(4)}
                            />

                            <label htmlFor='earlyArrival'>
                                {
                                    langResources['inconsistencies.modal'][
                                    'earlyArrival.label'
                                    ]
                                }
                            </label>
                        </div>

                        <div className='col-4 checked-custom  mt-2'>
                            <input
                                className='form-check-input me-1'
                                type='checkbox'
                                name='incomplete'
                                id='incomplete'
                                checked={inconsistenciesTypes.includes(5)}
                                onChange={(e) => handleInputChange(5)}
                            />

                            <label htmlFor='incomplete'>
                                {
                                    langResources['inconsistencies.modal'][
                                    'incompleteTimeAttendance.label'
                                    ]
                                }
                            </label>
                        </div>

                        <div className='col-4 checked-custom  mt-2'>
                            <input
                                className='form-check-input me-1'
                                type='checkbox'
                                name='Unscheduled Event'
                                id='UnscheduledEvent'
                                checked={inconsistenciesTypes.includes(6)}
                                onChange={(e) => handleInputChange(6)}
                            />

                            <label htmlFor='UnscheduledEvent'>
                                Marcaciones Fuera de Turno
                            </label>
                        </div>

                        <div className='col-4 checked-custom  mt-2'>
                            <input
                                className='form-check-input me-1'
                                type='checkbox'
                                name='earlyEvents'
                                id='earlyEvents'
                                checked={inconsistenciesTypes.includes(7)}
                                onChange={(e) => handleInputChange(7)}
                            />
                            <label htmlFor='earlyEvents'>
                                {
                                    langResources['inconsistencies.modal'][
                                    'earlyEvents.label'
                                    ]
                                }
                            </label>
                        </div>

                        <div className='col-4 checked-custom  mt-2'>
                            <input
                                className='form-check-input me-1'
                                type='checkbox'
                                name='all'
                                id='all'
                                onChange={(e) => setIsAll(!isAll)}
                            />

                            <label htmlFor='all'>
                                {
                                    langResources['inconsistencies.modal'][
                                    'allInconsistencies.label'
                                    ]
                                }
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
